import { Avatar, Points } from '@infl-ts/ui-advocate-components';
import { Box, ListItemAvatar, ListItemText, MenuItem, Typography } from '@mui/material';
import { constVoid } from 'fp-ts/function';
import { forwardRef } from 'react';
import { MenuLink } from './account-menu-links';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var ProfileLink = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var profile = _ref.profile,
      isDesktop = _ref.isDesktop,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? constVoid : _ref$onClick;
  return /*#__PURE__*/_jsx(MenuItem, {
    sx: {
      display: 'flex',
      flexDirection: 'row',
      '&:hover': {
        textDecoration: 'none'
      }
    },
    children: isDesktop ? /*#__PURE__*/_jsx(Box, {
      style: {
        width: '100%'
      },
      onClick: onClick,
      children: /*#__PURE__*/_jsxs(MenuLink, {
        href: "/profiles/".concat(profile.id),
        sx: {
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          width: '100%'
        },
        children: [/*#__PURE__*/_jsx(ListItemAvatar, {
          children: /*#__PURE__*/_jsx(Avatar, {
            member: profile !== null && profile !== void 0 ? profile : {
              id: '0',
              name: 'Unknown member'
            },
            disabledPopover: true
          })
        }), /*#__PURE__*/_jsx(ListItemText, {
          primary: /*#__PURE__*/_jsx(Box, {
            sx: {
              whiteSpace: 'initial'
            },
            children: profile.name
          }),
          secondary: /*#__PURE__*/_jsx(Points, {
            sx: {
              mr: 0.5
            },
            iconSize: "inherit",
            points: profile.currentPoints
          })
        })]
      })
    }) : /*#__PURE__*/_jsx(Box, {
      style: {
        width: '100%'
      },
      onClick: onClick,
      children: /*#__PURE__*/_jsxs(MenuLink, {
        sx: {
          width: '100%',
          display: 'flex',
          whiteSpace: 'initial'
        },
        href: "/profiles/".concat(profile.id),
        children: [/*#__PURE__*/_jsx(ListItemAvatar, {
          ref: ref,
          sx: {
            mr: 2,
            ml: 1
          },
          children: /*#__PURE__*/_jsx(Avatar, {
            size: "medium",
            member: profile !== null && profile !== void 0 ? profile : {
              id: '0',
              name: 'Unknown member'
            },
            disabledPopover: true
          })
        }), /*#__PURE__*/_jsx(ListItemText, {
          primary: /*#__PURE__*/_jsx(Typography, {
            sx: {
              color: function color(t) {
                return t.palette.text.primary;
              },
              fontWeight: function fontWeight(t) {
                return t.typography.fontWeightRegular;
              }
            },
            variant: "h2",
            children: profile.name
          }),
          secondary: /*#__PURE__*/_jsx(Points, {
            sx: {
              mr: 0.5
            },
            variant: "h3",
            iconSize: "inherit",
            points: profile.currentPoints
          })
        })]
      })
    })
  });
});
ProfileLink.displayName = 'ProfileLink';
export default ProfileLink;